import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import usePricelineStore from '../../store/hotel/priceline';
import useSearchStore from '../../store/hotel/search';
import useSearchHooks from '../../store/hotel/search-hooks';

export default function Pagination() {
  const { filterList } = usePricelineStore((state) => ({
    filterList: state.filterList,
  }));
  const { page } = useSearchStore((state) => ({ page: state.page }));
  const { setPricelinePage } = useSearchHooks();

  if (filterList.length === 0) {
    return <></>;
  }
  const pageSize = Math.ceil(+filterList.length / 20);
  return (
    <Row className="mt-3">
      <Col xs={2} className="d-grid gap-2">
        <Button variant="primary" className="btn-select" disabled={+page <= 1} onClick={() => setPricelinePage(+page - 1)}>
          <FontAwesomeIcon icon={faAngleLeft} size="1x" /> Prev Page
        </Button>
      </Col>
      <Col className="d-grid gap-2 justify-content-center">
        <p className="">
          Current Page {+page} {pageSize === 1 ? '/ Total Page' : '/ Total Pages'} {pageSize}
        </p>
      </Col>
      <Col xs={2} className="d-grid gap-2">
        <Button variant="primary" className="btn-select" disabled={+page >= pageSize} onClick={() => setPricelinePage(+page + 1)}>
          Next Page <FontAwesomeIcon icon={faAngleRight} size="1x" />
        </Button>
      </Col>
    </Row>
  );
}
